import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openMultiUpdateClientModal = asyncModalAdapter({
	upModalName: 'UpdateClientMulti',
	openModalName: 'MultiUpdateClient',
	rejectOnEvent: true
});
